import { defHttp } from '@/utils/http/axios';

let __cache = {};

export const clearCache = () => {
  __cache = {};
};

export const createCache = (url: string, params?: any) => {
  if (__cache[url]) {
    return __cache[url];
  }
  __cache[url] = defHttp.get({
    url,
    params,
  });
  return __cache[url];
};

export const createPostCache = (url: string, params?: any) => {
  if (__cache[url]) {
    return __cache[url];
  }
  __cache[url] = defHttp.post({
    url,
    params,
  });
  return __cache[url];
};
